import React, { useState } from 'react'
import { gql, useMutation } from 'urql'
import FormDialog from '../dialogs/FormDialog'
import { useLocation } from 'wouter'
import ScheduleSelectionForm from './ScheduleSelectionForm'

const createMutation = gql`
  mutation createScheduleSelection($input: CreateScheduleSelectionInput!) {
    createScheduleSelection(input: $input) {
      id
    }
  }
`

interface ScheduleSelectionCreateDialogProps {
  onClose: () => void
}

export interface ScheduleSelectionFormValue {
  name: string
  timeZone: string
  rotationLengthDays: number
  startTime: string
  numRounds: number
  pickDeadlineMinutes: number
  timeoutAction: 'auto_assign' | 'skip'
  targetScheduleID: string
  userIDs: string[]
  notifySMS: boolean
}

const defaultValue: ScheduleSelectionFormValue = {
  name: '',
  timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  rotationLengthDays: 7,
  startTime: '',
  numRounds: 3,
  pickDeadlineMinutes: 1440,
  timeoutAction: 'auto_assign',
  targetScheduleID: '',
  userIDs: [],
  notifySMS: false,
}

export default function ScheduleSelectionCreateDialog(
  props: ScheduleSelectionCreateDialogProps,
): React.JSX.Element {
  const [value, setValue] = useState<ScheduleSelectionFormValue>(defaultValue)
  const [, navigate] = useLocation()
  const [createResult, commit] = useMutation(createMutation)

  return (
    <FormDialog
      title='Create Schedule Selection'
      maxWidth='md'
      loading={createResult.fetching}
      errors={
        createResult.error
          ? [{ message: createResult.error.message }]
          : undefined
      }
      onClose={props.onClose}
      onSubmit={() =>
        commit({
          input: {
            name: value.name,
            timeZone: value.timeZone,
            rotationLengthDays: value.rotationLengthDays,
            startTime: value.startTime,
            numRounds: value.numRounds,
            pickDeadlineMinutes: value.pickDeadlineMinutes,
            timeoutAction: value.timeoutAction,
            targetScheduleID: value.targetScheduleID || null,
            userIDs: value.userIDs,
            notifySMS: value.notifySMS,
          },
        }).then((res) => {
          if (!res.error) {
            props.onClose()
            navigate('/schedule-selections/' + res.data.createScheduleSelection.id)
          }
        })
      }
      disableSubmit={
        !value.name ||
        value.userIDs.length < 2 ||
        !value.startTime ||
        value.rotationLengthDays < 1 ||
        value.numRounds < 1
      }
      form={<ScheduleSelectionForm value={value} onChange={setValue} />}
    />
  )
}
